/* eslint-disable
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import * as keyboard from 'util/Keyboard';
import formatters from 'notebook/mediocre/formatted-text/formatters';
import FormattersConstants from 'notebook/mediocre/formatted-text/FormattersConstants';
import MultiSelectList from 'notebook/mediocre/selection/block/MultiSelectListMixin';

// eslint-disable-next-line no-restricted-syntax
const MultiSelectLinearList = _.extend({}, MultiSelectList, {
  // Components should also implement:
  // - tabRangeHandler
  // - deleteRangeHandler
  // - inputRangeHandler
  // - pasteRangeHandler: this method is responsible for calling preventDefault when pasting, which allows
  //                      the component to handle a FF bug. See: wyciwyp.extractImageFromPaste
  // - multiSetCopyText

  isIndexBetween(startIndex, endIndex, index) {
    if (this.compareIndex(startIndex, endIndex) > 0) {
      [startIndex, endIndex] = Array.from([endIndex, startIndex]);
    }
    return this.compareIndex(startIndex, index) <= 0 && this.compareIndex(index, endIndex) <= 0;
  },

  allowSingleMultiSelect() {
    return false;
  },

  multiInputHandler({index, text}) {
    const range = this.sortedMultiRange();
    if (this.inputRangeHandler == null || range == null) {
      return;
    }
    this.saveMultiSelect();
    const {start, end} = range;
    if (start === end && text !== '') {
      // If only 1 item is selected and we're not performing a cut, don't replace it
      return;
    }
    this.inputRangeHandler({start, end, text});
  },

  multiPasteHandler(e) {
    const range = this.sortedMultiRange();
    if (this.pasteRangeHandler == null || range == null) {
      e.preventDefault();
      return;
    }
    this.saveMultiSelect();
    const {start, end} = range;
    this.pasteRangeHandler({start, end, originalEvent: e});
  },

  multiArrowSelectHandler(index, e) {
    const {up} = e;
    if (up) {
      this.setMultiIndices({
        start: index,
        end: this.previousIndex(index),
      });
    } else {
      this.setMultiIndices({
        start: index,
        end: this.nextIndex(index),
      });
    }
    // Clear the selection
    this.setSelection(null);
  },

  multiKeyDownHandler(e) {
    let end, start, targetIndex;
    if (keyboard.isTabKey(e)) {
      e.preventDefault();
      if (this.tabRangeHandler != null && !this.isLockedWithEditWarn()) {
        this.saveMultiSelect();
        ({start, end} = this.sortedMultiRange());
        this.tabRangeHandler({
          start,
          end,
          shiftKey: e.shiftKey,
        });
      }
    } else if (keyboard.isADeleteKey(e)) {
      e.preventDefault();
      if (this.deleteRangeHandler != null && !this.isLockedWithEditWarn()) {
        this.saveMultiSelect();
        ({start, end} = this.sortedMultiRange());
        this.deleteRangeHandler({
          start,
          end,
        });
      }
    } else if (keyboard.isUpKey(e)) {
      e.preventDefault();
      targetIndex = this.previousIndex(this.state.multiEndIndex);
      if (e.shiftKey) {
        this.setState({multiEndIndex: targetIndex});
      } else {
        this.setMultiIndices({
          start: targetIndex,
          end: targetIndex,
        });
      }
    } else if (keyboard.isDownKey(e)) {
      e.preventDefault();
      targetIndex = this.nextIndex(this.state.multiEndIndex);
      if (e.shiftKey) {
        this.setState({multiEndIndex: targetIndex});
      } else {
        this.setMultiIndices({
          start: targetIndex,
          end: targetIndex,
        });
      }
    } else if (keyboard.isCtrlA(e)) {
      e.preventDefault();
      this.setMultiIndices({
        start: this.firstIndex(),
        end: this.lastIndex(),
      });
    } else if (keyboard.isEnterKey(e)) {
      ({start, end} = this.sortedMultiRange());
      if (start === end && !this.isLockedWithEditWarn()) {
        // If only 1 item is selected, insert item below (or above if shift is pressed) instead of replacing it
        const newIndex = e.shiftKey ? start - 1 : start;
        e.preventDefault();
        this.insertItemHandler(newIndex);
      }
    } else {
      const format = formatters.formatTypeFromKeydown(e, {allowLink: false});
      if (format === FormattersConstants.SYMBOL) {
        // Can't insert symbol with multiple items selected
        return;
      }
      if (format != null) {
        e.preventDefault();
        if (this.formatRangeHandler != null && !this.isLockedWithEditWarn()) {
          this.saveMultiSelect();
          ({start, end} = this.sortedMultiRange());
          this.formatRangeHandler({start, end, format});
        }
      }
    }
  },
});

export default MultiSelectLinearList;
